import { UserInformation } from '@/OptimusRoutes/entities/userInformation.entity';
import { ActionType } from '@/types/actionType';
import { Action } from './actions';

type State = UserInformation;

const initialState: State = {
	allowSmsNotifications: false,
	featureFlags: {},
	isGoogleConnected: false,
	isAppleConnected: false,
	isPastDue: false,
};

const reducer = (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case ActionType.SESSION_UPDATE_INFORMATION: {
			return action.payload as UserInformation;
		}
		case ActionType.SESSION_UPDATE_IS_PAST_DUE: {
			return {
				...state,
				isPastDue: action.payload as boolean,
			};
		}
		case ActionType.CLEAN_REDUCER:
		case ActionType.LOG_OUT:
			return initialState;
		default:
			return state;
	}
};

export default reducer;
